import produce from 'immer'

import * as personalTokensCache from './personalTokensCache'

import {
  usePersonalTokenCreateMutation,
  PersonalTokenCreateMutation,
  PersonalTokenCreateMutationVariables,
} from '@sketch/gql-types'

type UseCreatePersonalTokenProps = {
  onCompleted: (
    data: PersonalTokenCreateMutation['personalTokenCreate']
  ) => void
}

export const useCreatePersonalToken = (props: UseCreatePersonalTokenProps) => {
  const { onCompleted } = props
  const [mutation] = usePersonalTokenCreateMutation({
    onError: 'show-toast',
    onCompleted: data => onCompleted(data.personalTokenCreate),
  })

  return async (variables: PersonalTokenCreateMutationVariables) => {
    return await mutation({
      variables,
      update: (cache, { data, errors }) => {
        if (!data || (errors && errors.length > 0)) return

        const me = personalTokensCache.get(cache)
        if (!me) return

        const personalToken = data.personalTokenCreate.personalToken!

        const updatedMe = produce(me, user => {
          user.personalTokens.unshift(personalToken)
        })

        personalTokensCache.set(cache, updatedMe)
      },
    })
  }
}
